if (!customElements.get('product-accordion-popup')) {
  class ProductAccordionPopup extends HTMLElement {
    constructor() {
      super();
      this.openTriggers = document.querySelectorAll('[data-accordion-popup-open]');
      this.closeTriggers = document.querySelectorAll('[data-accordion-popup-close]');
    }

    connectedCallback() {
      this.openTriggers.forEach(trigger => {
        trigger.addEventListener('click', this.openPopup.bind(this));
      });
      this.closeTriggers.forEach(trigger => {
        trigger.addEventListener('click', this.closePopup.bind(this));
      });
      this.addEventListener('click', (event) => {
        if (event.target === this) {
          this.closePopup();
        }
      });
    }

    openPopup() {
      this.setAttribute('open', '');
    }

    closePopup() {
      this.removeAttribute('open');
    }
  }

  customElements.define('product-accordion-popup', ProductAccordionPopup);
}